import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import NewItemsTable from './components/NewItemsTable';

const NewItems = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Inventory / New Items</h5>
      </Col>
    </Row>
    <Row>
      <NewItemsTable />
    </Row>
  </Container>
);

export default NewItems;
